import {inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {PolicyModalComponent} from '../../../features/legal/policy-modal/policy-modal.component';

export type PolicyModalMode = 'first-time' | 'update';

@Injectable({providedIn: 'root'})
export class PolicyModalService {
    private readonly dialogService = inject(DialogService);
    private readonly translate = inject(TranslateService);
    private dialogRef: DynamicDialogRef | null = null;

    open(mode: PolicyModalMode): DynamicDialogRef {
        const headerKey = mode === 'first-time'
            ? 'legal.acceptance.firstTimeTitle'
            : 'legal.acceptance.updateTitle';

        this.dialogRef = this.dialogService.open(PolicyModalComponent, {
            data: {mode},
            header: this.translate.instant(headerKey),
            width: 'min(700px, 90vw)',
            styleClass: 'admin-dialog policy-acceptance-dialog',
            modal: true,
            closable: false,
            closeOnEscape: false,
            dismissableMask: false,
        });

        return this.dialogRef;
    }

    close(): void {
        this.dialogRef?.close();
        this.dialogRef = null;
    }
}
